import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unverified-accounts',
  templateUrl: './unverified-accounts.component.html',
  styleUrls: ['./unverified-accounts.component.css']
})
export class UnverifiedAccountsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}